module.exports = __webpack_public_path__ + "static/img/SAAS专业版背景@2x.704fc2e8.png";